// Pathbuddy.com marketing footer — same multi-column layout as exam
// subdomain editorial footers, with generalized (non-exam-specific) routes.
// edu.ivori.ai and *.edu.ivori.ai keep their own footers.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CookieSettingsButton from '../consent/CookieSettingsButton';
import './PathbuddySiteFooter.css';

export default function PathbuddySiteFooter() {
  const navigate = useNavigate();

  const handleNav = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="pb-site-footer">
      <div className="pb-site-footer-container">
        <div className="pb-site-footer-grid">
          <div>
            <div className="pb-site-footer-logo">Pathbuddy</div>
            <p className="pb-site-footer-blurb">
              The AI for decision-makers. Tuned for the ones about to become one.
            </p>
            <p className="pb-site-footer-contact-label">Questions? Email us:</p>
            <a href="mailto:hello@pathbuddy.com" className="pb-site-footer-mail">
              hello@pathbuddy.com
            </a>
          </div>

          <div className="pb-site-fcol">
            <h4>Company</h4>
            <a href="https://ivorilab.com" target="_blank" rel="noopener noreferrer">
              IVORI Lab
            </a>
            <button type="button" onClick={() => handleNav('/method/pathbuddy')}>
              Pathbuddy Method
            </button>
            <h4 style={{ marginTop: 36 }}>Products</h4>
            <a href="https://ivoriai.com" target="_blank" rel="noopener noreferrer">
              IVORI
            </a>
            <button type="button" onClick={() => handleNav('/')}>
              Pathbuddy
            </button>
          </div>

          <div className="pb-site-fcol">
            <h4>Features</h4>
            <button type="button" onClick={() => handleNav('/features/chat')}>
              Chat
            </button>
            <button type="button" onClick={() => handleNav('/features/fluid')}>
              Fluid
            </button>
            <button type="button" onClick={() => handleNav('/features/studio')}>
              Studio
            </button>
            <button type="button" onClick={() => handleNav('/features/apps')}>
              Apps
            </button>
            <button type="button" onClick={() => handleNav('/features/cases')}>
              Cases
            </button>
          </div>

          <div className="pb-site-fcol">
            <h4>Exam Apps</h4>
            <a href="https://esat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">
              ESAT
            </a>
            <a href="https://lnat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">
              LNAT
            </a>
            <a href="https://tara.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">
              TARA
            </a>
            <a href="https://tmua.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">
              TMUA
            </a>
            <a href="https://ucat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">
              UCAT
            </a>
          </div>

          <div className="pb-site-fcol pb-site-fcol-wide">
            <h4>Interview Apps</h4>
            <a href="https://oxbridge.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">
              Oxbridge
            </a>
            <a href="https://medicalschool.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">
              Medical School
            </a>
            <a
              href="https://degreeapprenticeship.edu.ivoriai.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="pb-site-nowrap-link"
            >
              Degree Apprenticeship
            </a>
            <h4 style={{ marginTop: 36 }}>Resources</h4>
            <button type="button" onClick={() => handleNav('/insights')}>
              Insights
            </button>
            <button type="button" onClick={() => handleNav('/pricing')}>
              Pricing
            </button>
          </div>
        </div>
      </div>

      <div className="pb-site-footer-bottom-outer">
        <div className="pb-site-footer-container pb-site-footer-bottom">
          <span>© {new Date().getFullYear()} IVORI Lab. all rights reserved.</span>
          <div className="pb-site-footer-links">
            <button type="button" onClick={() => handleNav('/privacy')}>
              Privacy
            </button>
            <button type="button" onClick={() => handleNav('/terms-of-use')}>
              Terms
            </button>
            <button type="button" onClick={() => handleNav('/safeguarding')}>
              Safeguarding
            </button>
            <button type="button" onClick={() => handleNav('/cookies')}>
              Cookies
            </button>
            <CookieSettingsButton />
          </div>
        </div>
      </div>
    </footer>
  );
}
